






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'APIProp'
})
export default class APIProp extends Vue {
	@Prop({ type: String, required: true })
	name: string;

	@Prop({ type: String, required: true })
	type: string;

	@Prop([String, Object])
	typeLink: string | object;

	@Prop(String)
	defaultValue: string;

	@Prop([String, Object])
	defaultValueLink: string | object;
}
